'use client'

import { BottomCTA, Text } from '@macarongfactory/web-ui'
import { forwardRef } from 'react'

import {
  LOCK_AB_AF_SUB2,
  withLockAbAfSubs,
} from '@/app/(makers)/modoocar/_features/modoocar-lock-ab'
import {
  getCurrentPagePath,
  useSeoOnelinkUrl,
  withWebshowAfDp,
} from '@/shared/external/onelink'

import {
  RANK_CTA_ONELINK_URL,
  RANK_TRACK_CODE,
  RANK_VISIBLE_LIMIT,
  useRankTrackingContext,
} from '../_features/rank'

const CTA_BUTTON_TEXT_FULL = '마이클 앱에서 전체보기'
const CTA_BUTTON_TEXT_CONVENIENT = '마이클 앱에서 편하게 보기'
const MOBILE_CTA_MAX_WIDTH_PX = 480

interface IRankBottomCtaProps {
  /** 0이면 상단 안내 문구를 숨긴다 */
  totalCount: number
  visible: boolean
  /** 쿠키가 없거나 실험 제외면 null이라 붙이지 않는다 */
  afSub1: string | null
}

/** 스크롤을 내리면 숨기고, 올리거나 맨 아래에 닿으면 보인다. 데스크탑에서는 숨긴다 */
const RankBottomCta = forwardRef<HTMLDivElement, IRankBottomCtaProps>(
  ({ totalCount, visible, afSub1 }, ref) => {
    const onelinkUrl = useSeoOnelinkUrl(RANK_CTA_ONELINK_URL)
    const track = useRankTrackingContext()

    // 노출된 CTA 문구(전체보기/편하게 보기)로 분기 — 트래킹 라벨도 노출 문구 기준으로 구분한다
    const buttonText =
      totalCount >= RANK_VISIBLE_LIMIT
        ? CTA_BUTTON_TEXT_FULL
        : CTA_BUTTON_TEXT_CONVENIENT

    const handleClick = () => {
      track.itemClick(
        RANK_TRACK_CODE.BOTTOM_CTA,
        'button',
        `${buttonText} 클릭`
      )
      // 랭킹 URL은 동적이라 webshow로 현재 랭킹 페이지 경로를 실어 보낸다(앱 홈 낙하 방지)
      // af_sub1(변형)·af_sub2(rank_bottom_cta)를 붙인다 (WEB-5768)
      window.location.href = withLockAbAfSubs(
        withWebshowAfDp(onelinkUrl, getCurrentPagePath()),
        { afSub1, afSub2: LOCK_AB_AF_SUB2.RANK_BOTTOM_CTA }
      )
    }

    return (
      <div
        ref={ref}
        className={`fixed bottom-0 left-0 right-0 z-50 mx-auto transition-transform duration-300 ease-out lg:hidden ${
          visible ? 'translate-y-0' : 'translate-y-full'
        }`}
        style={{ maxWidth: MOBILE_CTA_MAX_WIDTH_PX }}
      >
        <BottomCTA.Vertical
          position='relative'
          top={
            totalCount > 0 ? (
              <Text
                variant='title-2-medium'
                color='text-foreground-neutral-alternative'
                className='block w-full text-center'
              >
                {`실시간으로 ${totalCount.toLocaleString()}개 차량 모델 랭킹 집계중`}
              </Text>
            ) : undefined
          }
          mainButton={
            <BottomCTA.MainButton.SolidButton
              text={buttonText}
              onClick={handleClick}
            />
          }
        />
        <div
          className='bg-background-surface-default'
          style={{ height: 'env(safe-area-inset-bottom)' }}
        />
      </div>
    )
  }
)

RankBottomCta.displayName = 'RankBottomCta'

export default RankBottomCta
